<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Svårighetsnivå
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Ersätter portionsinformationen i receptkortets meta-rad. En färgad prick +
      text kommunicerar nivå utan att ta upp mycket plats.
    </p>

    <PreviewBox label="Nivåer">
      <div v-for="l in levels" :key="l.label" class="flex items-center gap-1.5">
        <span
          class="w-[6px] h-[6px] rounded-full inline-block shrink-0"
          :style="{ backgroundColor: l.color }"
        />
        <span class="text-[12px] font-semibold" :style="{ color: l.color }">{{
          l.label
        }}</span>
      </div>
    </PreviewBox>

    <PreviewBox label="I meta-raden (kontext)">
      <div class="flex items-center gap-2 w-full">
        <span class="font-[Plus_Jakarta_Sans] text-[13px] text-[#6c7a77]"
          >⏱ 25 min</span
        >
        <span class="text-[#d0d5d4] text-[10px]">•</span>
        <span class="flex items-center gap-1">
          <span
            class="w-[6px] h-[6px] rounded-full bg-[#f59e0b] inline-block shrink-0"
          />
          <span class="text-[12px] font-semibold text-[#f59e0b]">Medel</span>
        </span>
        <span class="flex-1" />
        <PhHeart :size="18" class="text-slate-400" />
      </div>
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { PhHeart } from "@phosphor-icons/vue";
import PreviewBox from "../components/PreviewBox.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<!-- Svårighetsnivå i receptkort -->
<!-- Färger: enkel #16a34a | medel #f59e0b | avancerad #ef4444 -->
<div class="flex items-center gap-1.5">
  <span
    class="w-[6px] h-[6px] rounded-full flex-shrink-0"
    :style="{ backgroundColor: difficultyColor }"
  />
  <span class="font-[Poppins] font-semibold text-[12px]" :style="{ color: difficultyColor }">
    {{ difficultyLabel }}
  </span>
</div>`;
const cssCode = `/* Svårighet-punkt */
width: 6px;     /* w-[6px] */
height: 6px;    /* h-[6px] */
border-radius: 9999px;
flex-shrink: 0;

/* Svårighet-text */
font-family: 'Poppins', sans-serif;
font-weight: 600;
font-size: 12px;

/* Färger */
/* Enkel:     */ color: #16a34a;  /* green-600 */
/* Medel:     */ color: #f59e0b;  /* amber-400 */
/* Avancerad: */ color: #ef4444;  /* red-500 */`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
const levels = [
  { label: "Enkel", color: "#16a34a" },
  { label: "Medel", color: "#f59e0b" },
  { label: "Avancerad", color: "#ef4444" },
];
</script>
